// extracted by mini-css-extract-plugin
export var fullHeightState = "_58-7";
export var headerCell = "_58-1";
export var loadingStateCell = "_58-4";
export var rowWrapper = "_58-3";
export var standaloneTable = "_58-8";
export var standaloneTableWithBodyFill = "_58-9";
export var stateCell = "_58-5";
export var table = "_58-0";
export var tableBodyFiller = "_58-6";
export var white = "_58-2";